import React from 'react';
import RatePresenterGeneral from './tabs/RatePresenterGeneral';
import RatePresenterBillingPolicy from './tabs/RatePresenterBillingPolicy';
import RatePresenterGuestTypes from './tabs/RatePresenterGuestTypes';
import RatePresenterProducts from './tabs/RatePresenterProducts';
import RatePresenterRoomTypes from './tabs/RatePresenterRoomTypes';
import RatePresenterTaxesAndFees from './tabs/RatePresenterTaxesAndFees';
import RatePresenterHistory from './tabs/RatePresenterHistory';
import RatePresenterChannels from './tabs/RatePresenterChannels';
import RatePresenterSeasons from './tabs/RatePresenterSeasons';

export default class RatePresenterTabContent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <RatePresenterGeneral {...this.props} />
        <RatePresenterBillingPolicy {...this.props} />
        <RatePresenterGuestTypes {...this.props} />
        <RatePresenterProducts {...this.props} />

        <RatePresenterRoomTypes {...this.props} />
        <RatePresenterSeasons {...this.props} />
        <RatePresenterTaxesAndFees {...this.props} />
        <RatePresenterChannels {...this.props} />
        <RatePresenterHistory {...this.props} />
      </div>
    );
  };

};
